import { render, staticRenderFns } from "./VMNewContractInventoryPrices.vue?vue&type=template&id=12a89bae&scoped=true&"
import script from "./VMNewContractInventoryPrices.vue?vue&type=script&lang=js&"
export * from "./VMNewContractInventoryPrices.vue?vue&type=script&lang=js&"
import style0 from "./VMNewContractInventoryPrices.vue?vue&type=style&index=0&id=12a89bae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a89bae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VTextField,VTextarea})
